import React from 'react';

const Hero = () => (
  <section
    id="home"
    className="g-py-150"
    style={{
      backgroundImage: "url('/images/praying_hands.jpeg')",
      backgroundSize: 'cover',
      backgroundPosition: 'top center',
      backgroundRepeat: 'no-repeat',
      paddingTop: '3rem',
      paddingBottom: '3rem',
    }}
  >
    <div className="container g-bg-cover__inner">
      <div className="row align-items-center">
        <div className="col-lg-8 g-mb-30 g-mb-0--lg">
          <h3 className="h3 text-uppercase g-color-white g-mb-30">
            <span className="g-bg-primary-dark-v3 g-px-5">
              Welcome to Bishop K.J. Brown Ministries
            </span>
            <br />
            <span className="g-bg-primary-dark-v3 g-px-5">
              We are honored to have you visit! At Bishop K.J. Brown Ministries,
              our mission is simple: build winning lives through the Word of God.
              Whether you are seeking truth, healing, encouragement, or a deeper
              relationship with Jesus Christ, you have come to the right place.
            </span>
            <br />
            <span className="g-bg-primary-dark-v3 g-px-5">
              You matter to God — and to us.
            </span>
          </h3>

          <h4 className="h4 g-color-white g-mb-0">
            <span className="g-bg-black-opacity-0_6 g-px-5">
              Building Winning Lives, together.
            </span>
          </h4>
        </div>
        <div className="col-lg-4">&nbsp;</div>
      </div>
    </div>
  </section>
);

export default Hero;